import Vue from "vue";
import Vuex from "vuex";
import { $http } from "@/utils";
import course from "./course";
import game from "./game";
import material from "./material";
import { getPermissions } from "../api/courseList";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    course,
    game,
    material,
  },

  state: {
    user: {
    },
    permissions: [], // 权限列表
  },
  getters: {
    // 获取课时复制权限
    getPermissions(state) {
      return state.permissions.includes(562);
    },
    // 获取场景复制权限
    getPermissionsCopyScene(state) {
      return state.permissions.includes(592);
    },
    // 获取场景移动权限
    getPermissionsMoveScene(state) {
      return state.permissions.includes(580);
    },
    // 获取素材移动权限
    getPermissionsMoveMaterial(state) {
      return state.permissions.includes(585);
    },
    // 获取游戏复制权限
    getPermissionsCopyGame(state) {
      return state.permissions.includes(587);
    },
    // 获取游戏移动权限
    getPermissionsMoveGame(state) {
      return state.permissions.includes(586);
    },
    // 获取游戏课后复制权限
    getPermissionsCopyGameAfter(state) {
      return state.permissions.includes(591);
    },
    // 获取游戏课后移动权限
    getPermissionsMoveGameAfter(state) {
      return state.permissions.includes(590);
    },
  },
  actions: {
    initUserInfo({ commit }) {
      return $http.get("/user/init")
        .then(async (user) => {
          commit("initUserInfo", user);
          // 获取权限列表
          if (user && user.role && user.role.id) {
            const res = await getPermissions({ roleId: user.role.id });
            commit("initPermissions", res.permissions);
          }
          return user;
        });
    },
  },

  mutations: {
    initUserInfo(state, data) {
      state.user = { ...data };
    },
    initPermissions(state, data) {
      state.permissions = data;
    },
  },
});
